import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LandingPageGalleryImageAppResource from './LandingPageGalleryImageAppResource';

export const COVER = 'c1da5f83-b13f-4e20-9b05-0823c23364bc';
export const MAIN_IMAGE = '9d5d62f3-75c2-4ae1-adee-c5e1d139f27e';

export const ALL = {
    COVER,
    MAIN_IMAGE
};

class LuLandingPageGalleryTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-landing-page-gallery-type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/landings/pages/galleries/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'uuid',
            'slug',
            'title',
            'description',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            galleryImages: LandingPageGalleryImageAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default LuLandingPageGalleryTypeAppResource;
